import { useUnreadMessages } from "@/components/helpers/custom-hooks/use-unread-messages";
import { Box } from "@/components/layout/flexbox";
import { MessageSvg } from "@/components/pieces/icons/svg/message";
import { LinkButton } from "@/components/pieces/link/LinkButton";
import { CTA_COLOR } from "@/css/constants";

interface MessageButtonProps {
  chatChannelId: string;
  showMessageCount: boolean;
  linkUrl: string;
}

export function MessageButton({
  showMessageCount,
  chatChannelId,
  linkUrl,
}: MessageButtonProps) {
  const { unreadMessageCount, containerRef } = useUnreadMessages({
    showMessageCount,
    chatChannelId,
  });

  return (
    <div ref={containerRef}>
      <LinkButton className="!rounded-lg !p-3" to={linkUrl}>
        <Box minWidth={24}>
          <MessageSvg
            size={24}
            color={unreadMessageCount > 0 ? CTA_COLOR : "#2e3c47"}
          />
        </Box>
      </LinkButton>
    </div>
  );
}
